import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "px-2 text-lg leading-7 font-medium text-gray-900" }, "Manage Marketing Preferences for the enrolled contacts", -1)
const _hoisted_3 = { class: "flex flex-col gap-y-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-4 text-sm contacting-5 font-normal text-gray-500 pe-3" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Workflow"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Manual")
], -1)
const _hoisted_5 = { class: "border border-gray-200 rounded-xl flex flex-col" }
const _hoisted_6 = { class: "bg-gray-50 rounded-t-xl w-full grid grid-cols-4 py-2.5 px-4" }
const _hoisted_7 = { class: "flex text-gray-500 text-sm contacting-5 font-medium gap-x-1.5 items-center col-start-1 col-span-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Emails", -1)
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "rounded-b-xl w-full grid grid-cols-4 py-2.5 px-4" }
const _hoisted_12 = { class: "flex text-gray-500 text-sm contacting-5 font-medium gap-x-1.5 items-center col-start-1 col-span-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Messages", -1)
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "border border-gray-200 rounded-xl flex flex-col" }
const _hoisted_17 = { class: "rounded-t-xl w-full grid grid-cols-4 py-2.5 px-4" }
const _hoisted_18 = { class: "flex text-gray-500 text-sm contacting-5 font-medium gap-x-1.5 items-center col-start-1 col-span-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Phone Calls", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = { class: "bg-gray-50 rounded-b-xl w-full grid grid-cols-4 py-2.5 px-4" }
const _hoisted_23 = { class: "flex text-gray-500 text-sm contacting-5 font-medium gap-x-1.5 items-center col-start-1 col-span-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Property Alerts", -1)
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

import { BellIcon, ChatAltIcon, MailIcon, PhoneIcon } from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketingPreferencesComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()

return (_ctx: any,_cache: any) => {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(MailIcon), { class: "w-4 h-4" }),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_InputSwitch, {
              modelValue: _unref(workflowStore).marketingPreferences.isEnabledEmailWorkflow,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).marketingPreferences.isEnabledEmailWorkflow) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_InputSwitch, {
              modelValue: _unref(workflowStore).marketingPreferences.isEnabledEmailManual,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workflowStore).marketingPreferences.isEnabledEmailManual) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(ChatAltIcon), { class: "w-4 h-4" }),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_InputSwitch, {
              modelValue: _unref(workflowStore).marketingPreferences.isEnabledMessageWorkflow,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(workflowStore).marketingPreferences.isEnabledMessageWorkflow) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_InputSwitch, {
              modelValue: _unref(workflowStore).marketingPreferences.isEnabledMessageManual,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(workflowStore).marketingPreferences.isEnabledMessageManual) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_unref(PhoneIcon), { class: "w-4 h-4" }),
          _hoisted_19
        ]),
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_InputSwitch, {
            modelValue: _unref(workflowStore).marketingPreferences.isEnabledPhoneCallManual,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(workflowStore).marketingPreferences.isEnabledPhoneCallManual) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_unref(BellIcon), { class: "w-4 h-4" }),
          _hoisted_24
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_InputSwitch, {
            modelValue: _unref(workflowStore).marketingPreferences.isEnabledAlertWorkflow,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(workflowStore).marketingPreferences.isEnabledAlertWorkflow) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _hoisted_26
      ])
    ])
  ]))
}
}

})